import { kMaxLength } from "buffer";

// A cohesive dark theme for react-select
const baseSelectStyles = {
  control: (base, state) => ({
    ...base,
    backgroundColor: 'var(--select-bg)',
    borderColor: state.isFocused ? 'var(--accent)' : 'var(--select-border)',
    borderRadius: 12,
    minHeight: 44,
    paddingLeft: 2,
    boxShadow: state.isFocused ? `0 0 0 1px var(--accent), var(--focus-ring)` : 'none',
    ':hover': { borderColor: state.isFocused ? 'var(--accent)' : 'var(--select-border)' },
    cursor: 'text',
    opacity:1
  }),
  valueContainer: (base) => ({ ...base, paddingBlock: 6 }),
  placeholder: (base) => ({ ...base, color: 'var(--select-muted)' }),
  singleValue: (base) => ({ ...base, color: 'var(--select-text)' }),
  input: (base) => ({ ...base, color: 'var(--select-text)' }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: 'rgba(0,113,231,.25)',
    borderRadius: 10,
  }),
  multiValueLabel: (base) => ({ ...base, color: '#fff', fontWeight: 600 }),
  multiValueRemove: (base) => ({
    ...base,
    color: '#fff',
    ':hover': { backgroundColor: 'rgba(0,113,231,.45)', color: '#fff' },
  }),
  indicatorsContainer: (base) => ({ ...base, color: 'var(--select-muted)' }),
  dropdownIndicator: (base, state) => ({
    ...base,
    color: state.isFocused ? 'var(--accent)' : 'var(--select-muted)',
    ':hover': { color: 'var(--accent)' },
  }),
  clearIndicator: (base) => ({
    ...base,
    color: 'var(--select-muted)',
    ':hover': { color: '#fff' },
  }),
  menu: (base) => ({
    ...base,
    backgroundColor: '#0e1d30',
    border: '1px solid var(--select-border)',
    borderRadius: 12,
    overflow: 'hidden',
    marginTop: 6,
    zIndex: 9999, // just in case
  }),
  menuList: (base) => ({
    ...base,
    paddingBlock: 6,
    '::-webkit-scrollbar': { width: 10 },
    '::-webkit-scrollbar-thumb': {
      background: 'rgba(255,255,255,.12)',
      borderRadius: 8,
    },
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? 'rgba(0,113,231,.28)'
      : state.isFocused
      ? 'var(--select-bg-hover)'
      : 'transparent',
    color: 'var(--select-text)',
    padding: '10px 12px',
    cursor: 'pointer',
  }),
};

// Slightly taller control for your QuickSearch
export const searchSelectStyles = {
  ...baseSelectStyles,
    input: (base) => ({ ...base, opacity: 1, color: 'var(--select-text)' }),
  control: (base, state) => ({
    ...baseSelectStyles.control(base, state),
    minHeight: 48,
    kMaxLength:100,
    
  }),
};

// For the rest of the form selects
export const formSelectStyles = baseSelectStyles;

// Optional: compact variant if you need it for very tight rows
export const compactSelectStyles = {
  ...baseSelectStyles,
  control: (base, state) => ({
    ...baseSelectStyles.control(base, state),
    minHeight: 40,
  }),
};

// Optional helper to force an error border
export const errorSelectStyles = {
  ...formSelectStyles,
  control: (base, state) => ({
    ...formSelectStyles.control(base, state),
    borderColor: 'rgba(255,64,64,.75)',
    boxShadow: state.isFocused ? `0 0 0 1px rgba(255,64,64,.9), var(--focus-ring)` : 'none',
  }),
};
